module.exports = {"error":{"invalid_email":"Dieses ist eine falsche E-Mail Adresse"}}